import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const modules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
        ['link'],
        ['clean']
    ],
};

const formats = [
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link'
]; // whitelist of allowed tags. keeps images and other unsavory items from being pasted

const QuillEditor = ({ input = {} }) => (
    <ReactQuill
        {...input}
        onChange={(newValue, delta, source) => {
            if (source === 'user') {
                input.onChange(newValue);
            }
        }}
        onBlur={(range, source, quill) => {
            input.onBlur(quill.getHTML());
        }}
        modules={modules}
        formats={formats}
    />
);

export { QuillEditor as default };



// WEBPACK FOOTER //
// ./src/components/atoms/inputs/QuillEditor.js